import { StyleObject } from 'styletron-react';

export const keyHeading: StyleObject = {
	display: 'flex',
	flexDirection: 'row',
	flexWrap: 'wrap',
	justifyContent: 'space-evenly',
	alignItems: 'center',
	height: '50%'
};
export const subKeyHeading: StyleObject = {
	height: '130px',
	width: '40%',
	cursor: 'pointer'
};
export const cardCSS = {
	width: '100%',
	height: '100%'
};
